import React from 'react';

import { useTranslation } from 'react-i18next';

import Card from 'reactstrap/lib/Card';
import CardBody from 'reactstrap/lib/CardBody';
import CardTitle from 'reactstrap/lib/CardTitle';
import CardText from 'reactstrap/lib/CardText';

import { PaymentMethodInfo } from '@ttstr/api/orders';
import Currency from '@ttstr/components/Intl/Currency';

interface OwnProps {
  info: PaymentMethodInfo;
  color?: string;
}

type Props = Readonly<OwnProps>;

const CustomerFromOrder: React.FC<Props> = ({ info, color = 'info' }) => {
  const { t } = useTranslation();

  return (
    <Card className="mb-3" color={color}>
      <CardBody>
        <CardTitle tag="h2" className='h4'>{t(`ORDERS.DETAIL.PAYMENT_INFO.TITLE`)}</CardTitle>
        <CardText>{t(`ORDERS.DETAIL.PAYMENT_INFO.DESCRIPTION`)}</CardText>
        <dl className="dl-grid mb-0">
          {Object.entries(info).map(([key, value]) => (
            <React.Fragment key={key}>
              <dt className="text-right">{t(`ORDERS.DETAIL.PAYMENT_INFO.${key.toUpperCase()}`)}</dt>
              <dd className="text-monospace">{key.toUpperCase() === 'AMOUNT' ? <Currency value={value} /> : value}</dd>
            </React.Fragment>
          ))}
        </dl>
      </CardBody>
    </Card>
  );
};

export default React.memo(CustomerFromOrder);
